e4.cc = {
    init: function () {
        if ( jQuery( '.js-e-cc-list' ).length > 0 ) {
            e4.util.require.js( e4.settings.require.handlebars, function () {
                e4.handlebars.registerHelpers( 'compare counter' );
                e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-productlist-favorite-products #js-e-handlebars-tmpl-cart-msg-lastadded' );
                
            } );
        }
        e4.cc.lists.product.bindEvents();
        e4.cc.lists.list.bindEvents();
    },
    lists: {
        list: {
            bindEvents: function () {
                var jList = jQuery( '.js-e-cc-list' );
                jQuery(document).on( 'click', '.js-e-cc-list-product-remove', e4.cc.lists.list.removeProduct );
                jQuery(document).on( 'click', '.js-e-cc-list-product-add-to-cart', e4.cc.lists.list.addSingleProductToCart );
                jQuery(document).on( 'click', '.js-e-cc-list-delete', e4.cc.lists.list.delete );
                e4.cc.lists.list.bindNewListEvent();
            },
            removeProduct: function ( event ) {
                event.preventDefault();
                e4.cc.lists.ajax( {
                    url: event.target.href,
                    beforeSend: function(){
                        jQuery( event.target ).closest( '.js-e-cc-list-product' ).slideUp( function () {
                            jQuery( this ).closest( '.js-e-cc-list' ).find( '.js-e-cc-list-product-count' ).html( function ( index, oldhtml ) {
                                return parseInt( oldhtml ) - 1;
                            } );
                        } );
                    }
                });
            },
            addSingleProductToCart: function ( event ) {
                event.preventDefault();
                var jForm = jQuery( event.target ).closest( '.js-add-multi-single-form' ),
                    objProductData = {};
                jForm.find( 'input' ).each( function ( index, domInput ) {
                    var name = domInput.name.replace( jForm.data( 'index' ), '' );
                    objProductData[ name ] = domInput.value;
                } );
                e4.cart.addProduct( objProductData );
            },
            delete: function ( event ) {
                if ( confirm( jQuery( event.target ).data( 'confirm-msg' ) ) === false ) {
                    event.preventDefault();
                }
            },
            bindNewListEvent: function () {
                jQuery( document ).on( 'show.bs.collapse', '.js-dcc-favoritelist-collapse', function ( event ) {
                    if ( event.target.classList.contains( 'has-loaded' ) === false ) {
                        var listId = event.target.dataset.listId;
                        jQuery.ajax( {
                            method: 'POST',
                            url: e4.settings.ecom.favoriteProducts.url,
                            beforeSend: function () {
                            },
                            data: {
                                listId: listId
                            }
                        } ).done( function ( jsonData ) {
                            if ( jsonData.status === 'success' ) {
                                jQuery( event.target ).find( '.js-dcc-favorites-products-hbs-container' ).html( e4.handlebars.tmpl.productlistFavoriteProducts( jsonData ) );
                                event.target.classList.add( 'has-loaded' );
                            }
                            else {
                                event.target.classList.add( 'has-error' );
                                console.error( jsonData );
                            }
                        } );
                    }
                } );
            }
        },
        product: {
            bindEvents: function () {
                jQuery(document).on( 'submit', '.js-e-product-cc-list-form',function ( event ) {
                    event.preventDefault();
                } ).on( 'change', '.js-e-cc-list', e4.cc.lists.product.toggleList );
            },
            toggleList: function ( event ) {
                var jInput = jQuery( event.target );
                if ( jInput.prop( 'checked' ) === true ) {
                    e4.cc.lists.product.addToList( jInput );
                }
                else {
                    e4.cc.lists.product.removeFromList( jInput );
                }
            },
            addToList: function ( jInput ) {
                jInput.prop( 'disabled', true );
                fetch( jInput.data( 'url-add' ) + '&Redirect=false', { redirect: 'manual' } ).then( function () {
                    jInput.prop( 'disabled', false );
                } );
            },
            removeFromList: function ( jInput ) {
                jInput.prop( 'disabled', true );
                fetch( jInput.data( 'url-remove' ) + '&Redirect=false', { redirect: 'manual' } ).then( function () {
                    jInput.prop( 'disabled', false );
                } );
            }
        },
        ajax: function ( objAjaxSettings, fnCallback ) {
            var jqXHR = jQuery.ajax( jQuery.extend( {
                url: location.href,
                method: 'GET',
                dataType: 'html',
                cache: false
            }, objAjaxSettings ) );
            jqXHR.done( function () {
                if ( typeof fnCallback === 'function' ) {
                    fnCallback();
                }
            } );
            jqXHR.fail( function ( data, textStatus, errorThrown ) {
                console.error( data, textStatus, errorThrown );
            } );
        }
    }
};
